/**
 * Top level of the search page
 * Handles the page level stuff and triggers events on the individual search sources
 */
 
var SearchController = Backbone.Model.extend(
    /** @lends SearchControl.prototype */
    {
            
        defaults: function() {
            return {
                host_app: '',
                customer_id: 0,
                query_typed: '',
                lang: {},
                query_string: '',
                baseUrl: '',
                layout: 'tab',
                sources: [],
                tab_order: [],
                tab: '',
                selector: '',
                form_selector: '',
                header_selector: '',
                form_queue_id: 0,
                guide_id: 0,
                debug: false
            }
        },
        
        //@todo include default lang text
        
        /**
         * The main search controller
         * @param {String} host_app app where this js is currently running (la, lg, lc, etc)
         * @param {Number} customer_id libapps customer id
         * @param {String} query_typed what the user typed to search
         * @param {Object} lang language/translation values
         * @param {String} query_string url query string for current page
         * @param {String} baseUrl the path name for the current page, we need this for History states
         * @param {String} layout either tab or bento decides how many search interfaces are shown at once
         * @param {Array} sources array of search source objects with t.b.d. data in them used to create SearchInterface models
         * @param {Array} tab_order source ids of tab order
         * @param {String} [tab] current selected tab (for layout=tab only)
         * @param {String} selector selector for div that holds main interface (for tabs)
         * @param {String} [form_selector] selector for the search form (else we make one of our own)
         * @param {String} [header_selector] selector for area that says "search results for {{ query }}"
         * @param {Object} help parameters for the help alert
         * @todo decide what the hell to do with this
         * @param {String} help.noresults text when no results are found
         * @param {String} help.results text when results are found (shown at bottom of results)
         * @param {Number} help.la_widget_id for which widget to use in modal.
         * @param {Number} form_queue_id LA queue id for which form to display
         * @param {Number} guide_id For tracking searches from specific Guides (LG only)
         * @param {Boolean} debug set to true to output events/data to console
         */
        initialize: function() {
            this.set('baseUrl', location.pathname);
            this.protocol = window.location.protocol;
            
            //Set up history API so we can update URL and maintain forward/back buttons in browser
            this.useHistory = false;
            if (window.history && typeof history.pushState !== 'undefined') {
                //Enabled
                this.useHistory = true;
                this.History = window.History; // Note: We are using a capital H instead of a lower h	
                // Bind to State Change
                var self = this;
                this.History.Adapter.bind(window,'statechange',function(){
                    self.retrieve();
                });
            }
            
            // setup underscore template engine to use mustache style markers
            _.templateSettings = {
                escape:			/\{\{\{([^#].*?)\}\}\}/g,	// {{{ title }}}
                interpolate:	/\{\{([^#\{][\s\S]*?)\}\}/g,	// {{ title }}
                evaluate:		/\{\{#([\s\S]+?)\}\}/g			// {{# console.log("blah") }}
            }
            
            //to do a search we change the History state first
            this.on('search', this.pushState, this);
            //when the query gets changed we update elements of the page
            this.on('change:query_typed', this.updateQuery, this);
            
            //just a class to help on bento pages
            if (this.get('layout') == 'bento') {
                jQuery('body').addClass('s-srch-layout-bento');				
            }
            
            //figure out tabs and their order
            if ( this.get('layout') == 'tab' && this.get('tab_order').length == 0 ) {
                var tab_order = [];
                //first did we set it on the container
                var source_order = jQuery(this.get('selector')).attr('data-srch-sources');
                if (typeof source_order !== 'undefined' && source_order !== '') {
                    source_order = source_order.split(',');
                    _.each(source_order, function(v){
                        var s = _.findWhere(this.get('sources'), { id: parseInt(v, 10) });
                        if (typeof s !== 'undefined') {
                            tab_order.push(s.id);
                        }
                    }, this);
                    if (tab_order.length == 0) {
                        //gotta show something
                        tab_order = _.map(this.get('sources'), function(s){ return s.id; });
                    }
                } else {
                    //or just use them all
                    _.each(this.get('sources'), function(v,k,l){
                        tab_order.push(v.id);
                    });
                }
                this.set('tab_order', tab_order)
            }
            //set default tab
            if (this.get('layout') == 'tab' && this.get('tab') === '') {
                this.set('tab', this.get('tab_order')[0]);
            }
            
            var views = [];
            
            if (this.get('form_selector') !== '' && jQuery(this.get('form_selector')).length > 0) {
                var searchform = new SearchForm({ model: this, el: jQuery(this.get('form_selector')), formType: 'existing' });
            } else {
                var searchform = new SearchForm({ model: this, id: 's-srch-form' });
                views.push(searchform.el);
            }
            
            if (this.get('header_selector') == '' && this.get('layout') == 'tab') {
                var $header = $('<div id="s-srch-control-header"><h3></h3></div>');
                this.set('header_selector', '#s-srch-control-header');
                views.push($header);
            }
            
            //show tabs for more than 1 source
            if (this.get('layout') == 'tab' && this.get('tab_order').length > 1) {
                var tabs = new SearchTabs({ model: this, id: 's-srch-tabs' });
                views.push(tabs.el);
            }
            
            if (views.length > 0) {
                jQuery(this.get('selector')).append(views);
            }
        },
        /**
         * Debug (use in place of console.log())
         * @param {String|Number|Object} data data to log
         */
        debug: function(data) {
            if (this.get('debug')) {
                console.log(data);
            }
        },
        /**
         * Initialize the search source, we need to do this as separate from this.initialize() because we can't reference the searchcontroller in the sources until after it's initialized.
         */
        loadSources: function(){
    
            if (this.get('layout') == 'tab') {
                //set up tab content areas and source objects
                _.each(this.get('tab_order'), function(v,k,l){
                    var source = _.findWhere(this.get('sources'), { id: parseInt(v, 10) });
                    if (typeof source !== 'undefined') {
                        var selector = '#s-srch-source-'+source.id;
                        var $el = jQuery('<div id="s-srch-source-'+source.id+'"></div>').attr({ 'data-source': source.id, 'role': 'tabpanel' });
                        if (this.get('tab') != source.id) {
                            $el.addClass('hidden');
                        }
                        jQuery(this.get('selector')).append( $el );
                        source.lang = this.get('lang');
                        source.guide_id = this.get('guide_id'); // Add guide_id for searches initiated from a guide.
                        var sources = [];
                        switch (source.type){
                            case "la":
                                sources.push( new SearchLA(source) );
                                break;
                            case "lg":
                                sources.push( new SearchLG(source) );
                                break;
                            case "az":
                                sources.push( new SearchAZ(source) );
                                break;
                            case "blog":
                                sources.push( new SearchBlog(source) );
                                break;
                            default:
                                sources.push( new SearchInterface(source) );
                        }
                        
                        
                    }
                }, this);
                
                //In LA add the askform to the bottom
                if (this.get('host_app') == 'la') {
                    var askform = new AskView({ model: this, formtype: 'footer', alert_text: this.get('lang').srch_askqtext });
                    jQuery(this.get('selector')).append( askform.el );
                }
                
            } else {
                //bento
                _.each(this.get('sources'), function(v,k,l){
                    var selector = '#s-srch-source-'+v.id;
                    if (jQuery(selector).length == 0) {
                        return;
                    }
                    v.display_facets = false;
                    v.lang = this.get('lang');
                    var sources = [];
                    switch (v.type){
                        case "la":
                            sources.push( new SearchLA(v) );
                            break;
                        case "lg":
                            sources.push( new SearchLG(v) );
                            break;
                        case "az":
                            sources.push( new SearchAZ(v) );
                            break;
                        case "blog":
                            sources.push( new SearchBlog(v) );
                            break;                        
                        default:
                            sources.push( new SearchInterface(v) );
                    }
                }, this);
            }
            
        },
        /**
         * Update the history API state so we can change the url and enable back/forward button usage
         * Triggers the retrieve method
         * That is triggered outside of the controller via an event handler in search page
         */
        pushState: function() {
            this.debug('searchcontroller:pushState');
            var qs = this.buildQueryString();
            if (qs !== '') { qs = '?'+qs; } //so we don't have a trailing ? when there's a blank query string
            if (this.useHistory) {
                var title = jQuery('title').text();
                this.History.pushState(null,null,this.get('baseUrl')+qs);
                jQuery('title').text(title);
                //History.pushState(null,null,this.get('baseUrl')+qs);
                //statechange triggers an action... as set in initialize()
            } else {
                //if we don't have history (IE) just load new page
                window.location(this.get('baseUrl')+qs);
            }
        },
        /**
         * called on load and state change, triggers event that searchinterfaces listen for
         */
        retrieve: function() {
            this.debug('searchcontroller:retrieve');
            //parse the query string for parameters
            this.parseQueryString();
            
            this.trigger('search:initiate', { source: 'controller' });
            //leave it to the SearchInterfaces to decide whether they should run or not (based on tab/layout)
        },
        /**
         * What's in the query string? Let's make it an object we can use.
         */
        parseQueryString: function(){
            var qs = location.search.slice(1);
            this.set('query_string',qs);
            
            var pairs = qs.split('&');
            //this.debug(pairs);
            
            var result = {};
            
            _.each(pairs, function(pair) {
                pair = pair.split('=');
                if (pair[0] == '' || !pair[1]) { return; }
                
                if (pair[0] == 'q') {
                    result[pair[0]] = decodeURIComponent(pair[1].replace(/\+/g, ' ') || '');
                } else {
                    result[pair[0]] = decodeURIComponent(pair[1].replace(/\+/g, ' ') || '');
                }	
            }, this);
            
            if (result.q) {
                this.set('query_typed', result.q);
            } else {
                this.set('query_typed', '');
            }
            
            if (result.t) {
                this.set('tab', result.t);
            } else {
                //this.set('tab', '');
            }
            
            //Various facets
            if (result.topics && this.get('layout') == 'tab') {
                this.trigger('facet:set', { facet: 'topics', value: result.topics });
            }
            
            if (result.keywords && this.get('layout') == 'tab') {
                this.trigger('facet:set', { facet: 'keywords', value: result.keywords });
            }
    
            if (result.g && this.get('layout') == 'tab') {
                this.trigger('facet:set', { facet: 'g', value: result.g });
            }
            
            if (result.subject && this.get('layout') == 'tab') {
                this.trigger('facet:set', { facet: 'subject', value: result.subject });
            }
            
            if (result.tag && this.get('layout') == 'tab') {
                this.trigger('facet:set', { facet: 'tag', value: result.tag });
            }
            
            if (result.group && this.get('layout') == 'tab') {
                this.trigger('facet:set', { facet: 'group', value: result.group });
            }
            
            if (result.content_type && this.get('layout') == 'tab') {
                this.trigger('facet:set', { facet: 'content_type', value: result.content_type });
            }
            
            if (result.guide_type && this.get('layout') == 'tab') {
                this.trigger('facet:set', { facet: 'guide_type', value: result.guide_type });
            }
            
            return result;
        },
        /**
         * Build a query string (for the visible URL) based on current attributes
         * sets the query_string attribute
         */
        buildQueryString: function() {
            /*
                Fields we use and defaults:
                    query: '',
                    tab: '', //tab to show
                    topic: '', //can be passed to LA interface
            */
            
            var params = {};
            
            if (this.get('query_typed') !== '') {
                params.q = this.get('query_typed');
            }
            if (this.get('tab') !== '') {
                params.t = this.get('tab');
            }
            
            var qs = jQuery.param(params, true); //true makes sure we repeat keys in query string for arrays
            this.set('query_string',qs);
            return qs;
        },
        /**
         * on query change we update any qforms on the page, the search header
         */
        updateQuery: function() {
            var q = this.get('query_typed');
            
            //update forms
            $('textarea[name=pdetails]').val(q);
            //update header
            $(this.get('header_selector')).text(this.get('lang').srch_boxhead+' ').append( jQuery('<em></em>').text(q) );		
        }
            
    });
    
    /**
     * //!SearchForm View
     * The text input for searching (1 per page)
     */
    var SearchForm = Backbone.View.extend(
    /** @lends SearchForm.prototype */
    {
        
        model: SearchController,
        tagName: 'form',
        className: 'form-inline',
        formType: '',
        
        events: {
            'submit': 'submit',
        },
        
        initialize: function(options) {
            if (options.formType) {
                this.formType = options.formType;
            }
                    
            this.render();
            
            var q = this.model.get('query_typed');
            
            if (this.model.get('layout') == 'tab') {
                var $results_div = jQuery(this.model.get('selector'));
                var results_id = $results_div.attr('id');
                if (results_id == '') {
                    results_id = 's-srch-results-container';
                    $results_div.attr('id', results_id);
                }
                this.$input.attr('aria-controls', results_id);
            } else {
                //set this to all the ids for the results div(s)
    
            }
            
            this.$input.val(q);
            
            //this.setupAutocomplete();
            
            this.listenTo(this.model, 'change:query_typed', this.setQuery);
            //this.listenTo(this.input, 'typeahead:selected', sresults.goToAnswer)
        },
        
        render: function() {
            
            if (this.formType == 'existing') {
                this.$input = this.$('input[name=q]');
                return;			
            }
    
            var inputs = [];
            
            this.$input = jQuery('<input type="text" class="s-srch-form-input form-control" id="primaryquery" name="q" value="" />');
            var $label = jQuery('<label for="" class="control-label sr-only" for="primaryquery">Keyword Search</label>');
            
            inputs.push( jQuery('<div class="form-group"></div>').append([$label, this.$input]) );
            inputs.push( jQuery('<button type=submit class="btn btn-default">Search</button>') );
            
            this.$el.append(inputs);	
        },
        
        setQuery: function(e) {
                
            this.$input.val(this.model.get('query_typed'));
        },
        
        /**
         * search on a query
         */
        submit: function(e) {
            e.preventDefault();
            
            var new_query = this.$input.val(); 
            if (new_query !== this.model.get('query_typed')) {
            
                //check for odd number of quotes
                var quotes = (new_query.match(/"/g)||[]).length;
                //this.debug(quotes);
                if (quotes % 2 !== 0) {
                    errorAlert(this.model.get('lang').srch_syntaxerror);
                    return;
                }
            
                this.model.set('query_typed', new_query);
                this.model.trigger('search');
            }		
            //this.input.typeahead('close');
        },
        
        /**
         * Turn on the autocomplete
         * @todo this could probably be cleaner
         */
    /*
        setupAutocomplete: function() {
            
            var self = this;
            self.qo = this.model.buildQuery(true);    
            self.qo.rows = 10;
            
            //data source for typeahead
            //I think we could do this as a method on the view (or the model).
            //bind it to this
            var typeahead_source = function(query, cb) {
                var results = [];
                query = jQuery.trim(query);
                self.qo.q = query.replace(/([\(\)\[\]\{\}\^~:\\\/])/ig, '\\$1') + '*';
                //self.qo.q = query+'*';
                $.ajax({
                    url: 'http://'+self.model.get('solrUrl')+'/'+self.model.get('solrIndex')+'/select',
                    data: self.qo,
                    success: function(d){
                        results = jQuery.map(d.response.docs, function(item) {
                            return { value: item.question, faqid: item.id, gid: item.g };
                        });
                        cb(results);
                    },
                    traditional: true, //this lets the query have multiple parameters that don't use the [] syntax (cause solr wants that)
                    dataType: 'jsonp',
                    jsonp: 'json.wrf'
                });
                        
            }
            
            //enable autocomplete
            this.input.typeahead({ minLength: 3 },
                {
                    source: typeahead_source,
                    displayKey: 'value'
                }
            ).on('typeahead:selected', function(e, d){
                //when a suggestion is selected
                jQuery.ajax({
                    type: 'POST',
                    url: '/process_public.php?m=gotoa',
                    data: { faqid: d.faqid, qlog: springSpace.la.Page.qlog_id },
                    async: false,
                    success: function (data) {
                        return true;
                    }
                });
                
                window.location.href = '/a.php?gid='+d.gid+'&qid='+d.faqid;
            });
            
        },
    */
    
    
    });
    
    /**
     * //!SearchTabs View
     * The tabs for tabbed layout
     */
    var SearchTabs = Backbone.View.extend(
    /** @lends SearchTabs.prototype */
    {
        
        model: SearchController,
        tagName: 'div',
        id: 's-srch-tabs',
        
        events: {
            'click button': 'changeTab',
        },
        
        initialize: function() {
            this.model.debug('SearchTabs:initialize');
            if ( this.model.get('layout') !== 'tab') {
                return false;
            }
            
            this.render();
                    
            this.listenTo(this.model, 'change:tab', this.setTab);
        },
        /**
         * Change the tab
         */
        changeTab: function(e){
            e.preventDefault();
            var $b = $(e.currentTarget);
            var $li = $b.parent('li');
            if ($li.hasClass('active')) {
                return;
            }
            this.$('li').removeClass('active')
            this.$('button').attr({ 'aria-selected': 'false' });
            $li.addClass('active');
            $li.find('button').attr({ 'aria-selected': 'true' });
            var id = $li.attr('data-source');
            this.model.set('tab', id);
            this.model.trigger('search');
        },
        /**
         * Make the current tab display as active
         */
        setTab: function() {
            var tab = this.model.get('tab');
            this.$('li').removeClass('active');
            this.$('button').attr({ 'aria-selected': 'false' });
            this.$('li[data-source='+tab+']').addClass('active').find('button').attr({ 'aria-selected': 'true' });
        },
        /**
         * Render tabs
         */
        render: function() {
            this.model.debug('SearchTabs:render');
            this.$el.html('');
            
            var $ul = jQuery('<ul></ul>').addClass('list-inline').attr({ 'role': 'tablist'});
            
            var cur_tab = this.model.get('tab');
            this.model.debug(cur_tab);
            //_.each(this.model.get('sources'), function(v,k,l) {
            _.each(this.model.get('tab_order'), function(v,k,l){
                var source = _.findWhere(this.model.get('sources'), { id: parseInt(v, 10) });
                if (typeof source !== 'undefined') {
                    var $li = jQuery('<li></li>').attr({ 'data-source': source.id, 'role': 'presentation' });
                    var $button = jQuery('<button></button>').attr({ 'type': 'button', 'aria-controls': 's-srch-source-'+source.id, 'role': 'tab' }).addClass('btn btn-default').text(source.name);
                    if (cur_tab == source.id) {
                        $li.addClass('active');
                        $button.attr({ 'aria-selected': 'true' });
                    }
                    $li.append($button);
                    $ul.append($li);
                }
            }, this);
            this.model.debug(this.$el);
            this.$el.append($ul);
        }
        
    });
    
    //!AskView
    /**
     * This is used by the controller and the searchinterfaces to provide "no results" alerts/question form button
     */
    var AskView = Backbone.View.extend(
    /** @lends AskView.prototype */
    {
        
        model: SearchController,
        tagName: 'div',
        className: 's-srch-askbutton col-sm-12 hidden',
        formtype: 'noresults',
        alert_text: 'No results found.',
        
        events: {
            'click .btn': 'showQForm',
        },
        
        /**
         * Ask Q button
         */
        initialize: function (options) {
            if (options.formtype) {
                this.formtype = options.formtype;
            }
            if (options.alert_text) {
                this.alert_text = options.alert_text;
            }
            
            this.listenTo(this.model, "search:retrieve", this.results);
            this.listenTo(this.model, "search:noresults", this.noresults);
            this.listenTo(this.model, "askform:results", this.results);
            this.listenTo(this.model, "askform:noresults", this.noresults);
            this.render();
        },
        
        render: function () {
    
            var $span = $('<p class="alert alert-info"></p>').html(this.alert_text);
            
            if (searchcontroller.get('form_queue_id') > 0) {
                var $a = $('<a class="btn btn-primary" href="#" role=button></a>').html(this.model.get('lang').srch_askqbutton);
                $span.append($a);
            }
            
            this.$el.html($span);
                
        },
        /**
         * When results are found
         */
        results: function(){
            if (this.formtype == 'noresults') {
                this.$el.addClass('hidden').attr('aria-hidden', 'true');
            } else {
                this.$el.removeClass('hidden').attr('aria-hidden', 'false');
            }
        },
        /**
         * When results are not found
         */
        noresults: function(e){
            if (this.formtype == 'noresults') {
                this.$el.removeClass('hidden').attr('aria-hidden', 'false');
            } else {
                this.$el.addClass('hidden').attr('aria-hidden', 'true');
            }
        },
        /**
         * Onclick action for the no results 'Ask question' button
         * Pops up a modal with the qform
         */
        showQForm: function(e) {
            e.preventDefault();
            var query = this.model.get('query_typed');
            //this.model.debug(query);
            //var queue_id = this.model.get('form_queue_id');
            var queue_id = searchcontroller.get('form_queue_id');
            
            var url = '';
            
            //resize the iframe in the modal to match the size of the qform
            window.addEventListener('message', function(e){
                if (e.data && _.isObject(e.data) && e.data.action && e.data.action == 'qformloaded') {
                    if (e.data.height && parseInt(e.data.height, 10) > 0) {
                        jQuery('.qform_frame').css('height', e.data.height);
                    }
                }
            });
            
            var qlog_id = 0;
            if (springSpace && springSpace.querySpy) {
                qlog_id = springSpace.querySpy.qlog_id || 0;
            }
            
            var modal = new springSpace.sui.modal({ title: this.model.get('lang').srch_askqbutton, content: '<iframe class="qform_frame" src="/form.php?queue_id='+queue_id+'&iframe=1&qlog_id='+qlog_id+'&pquestion='+query+'"></iframe>', callback: function(){  } });
            
        },
        
    });
    
    
    //!HELPERS
    
    /**
     * Capitalize first letter of string
     */
    String.prototype.capitalize = function() {
        return this.charAt(0).toUpperCase() + this.slice(1);
    }
    
    
    /**
     * Compare two arrays
     * @param {Array} arr1
     * @param {Array} arr2
     * @returns {Boolean} are they the same
     */
    function compareArrays(arr1, arr2) {
        arr1 = arr1.sort();
        arr2 = arr2.sort();
        
        if (arr1.length != arr2.length)
            return false;
    
        for (var i = 0, l=arr1.length; i < l; i++) {
            // Check if we have nested arrays
            if (arr1[i] instanceof Array && arr2[i] instanceof Array) {
                // recurse into the nested arrays
                if (!arr1[i].compare(arr2[i]))
                    return false;
            }
            else if (arr1[i] != arr2[i]) {
                // Warning - two different object instances will never be equal: {x:20} != {x:20}
                return false;
            }
        }
        return true;
        
    }
    
    